var map = {
	"./bet-tnc-cn.svg": 2358,
	"./fifa-tnc-cn.svg": 2359,
	"./leaderboard-tnc-cn.svg": 2360,
	"./lucky-tnc-cn.svg": 2361,
	"./term-condition-bm.svg": 2362,
	"./term-condition-cn.svg": 2363,
	"./term-condition-id.svg": 2364,
	"./term-condition.svg": 2365,
	"./term-content.png": 2366,
	"./term-footer.png": 2367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;